var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreatment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.85255 18.0851L1.99021 17.5636C1.06739 17.0055 0.879493 15.6209 1.57133 14.4769L4.88934 8.99033L9.09874 11.536L5.78073 17.0225C5.08889 18.1665 3.77537 18.6431 2.85255 18.0851ZM11.6864 1.53024L12.5488 2.05174C13.4716 2.60982 13.6595 3.99447 12.9677 5.13846L9.64968 10.625L5.44028 8.07933L8.75828 2.5928C9.45011 1.44881 10.7636 0.972156 11.6864 1.53024ZM13.7029 5.58309C14.6987 3.93651 14.4279 1.94334 13.1 1.1403L12.2376 0.618795C10.9094 -0.184467 9.0188 0.501574 8.02303 2.14816L4.53874 7.90964C4.48582 7.95323 4.43805 8.00784 4.39918 8.07211C4.36031 8.13639 4.33439 8.20364 4.32036 8.27075L0.836077 14.0322C-0.159703 15.6788 0.110766 17.6717 1.43901 18.475L2.30135 18.9965C3.62923 19.7996 5.52018 19.1137 6.51596 17.4672L13.7029 5.58309Z",
    fill: "#2E7161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatment);
export default __webpack_public_path__ + "static/media/treatment.af75b335f01a87b9dcbf54c8456b119a.svg";
export { ForwardRef as ReactComponent };